import { Markdown } from '@/src/components/common/Markdown';
import { useJamChallengeDetails } from '@/src/store/jam-challenge-details.context';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { Box, Button, Container, SpaceBetween } from '@amzn/awsui-components-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const JamChallengeOverview: React.FC<{ contentLengthLimit?: number }> = ({ contentLengthLimit = 500 }) => {
  const { t } = useTranslation();
  const { selectedJamChallenge } = useJamChallengeDetails();
  const [fullOverview, setFullOverview] = useState(false);

  const { readFullScenario, readLess } = i18nKeys.myJams.challenges.details.overview;
  const toggleOverview = () => setFullOverview(!fullOverview);

  return (
    <Container>
      <Box variant="div">
        {!!selectedJamChallenge?.description && (
          <SpaceBetween size="s">
            <Markdown
              content={selectedJamChallenge?.description}
              truncate={fullOverview ? 0 : contentLengthLimit}
              allowHtml
            />
            {selectedJamChallenge?.description?.length > contentLengthLimit && (
              <Box padding={{ bottom: 'l' }}>
                <Button variant="inline-link" data-testid="show-full-scenario-btn" onClick={toggleOverview}>
                  {fullOverview ? t(readLess) : t(readFullScenario)}
                </Button>
              </Box>
            )}
          </SpaceBetween>
        )}
      </Box>
    </Container>
  );
};

export default JamChallengeOverview;
